// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider_base{border-bottom:0.5px solid #c9d1d5;width:100%}\n", ""]);
// Exports
module.exports = exports;
